import { z } from "zod";

/**
 * One live step of a running turn, as the server publishes it to the user's own
 * `ai-assistant:turns` channel (#7286). Mirrors `AssistantTurnStepEvent`.
 *
 * The label is the server's, from a fixed list it owns, so the panel shows it as it is and never
 * builds one. The sequence orders the steps of one turn: each is published without waiting for the
 * one before, so a later step can arrive first.
 */
export const AssistantTurnLiveStepZ = z.object({
  turnId: z.string().min(1),
  sequence: z.number().int().positive(),
  label: z.string().min(1).max(200),
});

export type AssistantTurnLiveStepJSON = z.infer<typeof AssistantTurnLiveStepZ>;
